const V1_TO_V2 = {
  'categories#flashcard': 'categories#flashcard-v2',
  'scenarios#flashcard': 'scenarios#flashcard-v2',
  'qotd#index': 'qotd#flashcard-v2',
  'deeplinks#flashcard': 'deeplinks#flashcard-v2',
};

const V2_TO_V1 = Object.fromEntries(
  Object.entries(V1_TO_V2).map(([v1, v2]) => [v2, v1]),
);

const FLIPCARD_V1_FAMILIES = new Set([
  'categories#flashcard',
  'categories#flashcard-v2',
  'deeplinks#flashcard',
  'deeplinks#flashcard-v2',
]);

export default {
  computed: {
    questionUiV2Enabled() {
      return this.$store.getters['app/questionUiV2Enabled'];
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    getCorrectRouteName(flashcardType) {
      if (flashcardType === 'Flipcard' && FLIPCARD_V1_FAMILIES.has(this.currentRouteName)) {
        return V2_TO_V1[this.currentRouteName] ?? this.currentRouteName;
      }
      const map = this.questionUiV2Enabled ? V1_TO_V2 : V2_TO_V1;
      return map[this.currentRouteName] ?? this.currentRouteName;
    },
    maybeRedirectToCorrectVersion(flashcardType) {
      const target = this.getCorrectRouteName(flashcardType);
      if (target && target !== this.$route.name) {
        this.$router.replace({
          name: target,
          params: this.$route.params,
          query: this.$route.query,
        }).catch(() => {});
        return true;
      }
      return false;
    },
  },
};
